<div class="flex flex-col">
    @if (label) {
        <div class="hypo-input-label">
            {{ label }}
            @if (showOptionalLabel()) {
                <span class="optional"></span>
            }
            @if (tooltip) {
                <app-tooltip [text]="tooltip"></app-tooltip>
            }
        </div>
    }

    <div class="flex flex-row items-start justify-start gap-5">
        <mat-form-field
            [class.has-info]="tooltip"
            [class.has-suffix-template]="suffixTemplate"
            [class.has-suffix]="suffix"
            [class.has-suffix-fill]="!suffixTemplate || (suffixTemplate && suffixFill)"
            [class.read-only]="readOnly"
            [floatLabel]="'always'"
            [formGroup]="formGroup"
            [class.highlight]="highlight"
            class="w-full">
            @if (!matAutocomplete) {
                <input
                    (blur)="onBlur()"
                    [attr.inputmode]="inputmode"
                    [attr.data-testid]="testId"
                    [dropSpecialCharacters]="dropSpecialCharacters"
                    [mask]="mask"
                    [placeholder]="placeholder"
                    [readonly]="readOnly"
                    [suffix]="maskSuffix"
                    formControlName="mainInput"
                    matInput="matInput"
                    type="text" />
            }
            @if (matAutocomplete) {
                <input
                    (blur)="onBlur()"
                    [attr.inputmode]="inputmode"
                    [attr.data-testid]="testId"
                    [matAutocomplete]="matAutocomplete"
                    [placeholder]="placeholder"
                    [readonly]="readOnly"
                    formControlName="mainInput"
                    matInput="matInput"
                    type="text" />
            }
            @if (input.hasError('required')) {
                <mat-error align="end"> Povinný údaj </mat-error>
            }
            @if (input.hasError('min')) {
                <mat-error align="end"> Musí být minimálně {{ input.errors['min'].min }} {{ suffix }} </mat-error>
            }
            @if (input.hasError('max')) {
                <mat-error align="end"> Musí být maximálně {{ input.errors['max'].max }} {{ suffix }} </mat-error>
            }
            @if (input.hasError('validPhone')) {
                <mat-error align="end"> Zadejte 9 číslic </mat-error>
            }
            @if (input.hasError('pattern')) {
                <mat-error align="end">
                    {{ patternErrorMessage || 'Špatný formát' }}
                </mat-error>
            }
            @if (input.hasError('twoWords')) {
                <mat-error align="end">
                    {{ patternErrorMessage || 'Musí obsahovat dvě slova' }}
                </mat-error>
            }
            @if (input.hasError('emailDuplicity')) {
                <mat-error align="end"> Email jste již použili u jiného žadatele. </mat-error>
            }
            @if (hint) {
                <mat-hint>{{ hint }}</mat-hint>
            }
            @if (suffix) {
                <span class="input-info" matSuffix="matSuffix">
                    {{ suffix }}
                </span>
            }
            @if (suffixTemplate) {
                <span matSuffix="matSuffix">
                    <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
                </span>
            }
        </mat-form-field>
        @if (step) {
            <div>
                <div class="buttons align-bottom" matSuffix="matSuffix">
                    <button (click)="minusValue()" mat-flat-button="mat-flat-button" type="button">
                        <mat-icon>remove</mat-icon>
                    </button>
                    <button (click)="plusValue()" mat-flat-button="mat-flat-button" type="button">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
